/**
 * Digby, the miner (docs/spec/04 §3): helmet and trousers in the earth colour, a lamp, face and
 * hands in the bright colour, shirt and boots in rock. Facing right is drawn; left is its mirror.
 */

import { frame, mirror } from './types';
import type { Frame } from './types';

const HELMET = '...33...|..1331..|.111111.|11111111|';
const EYES_OPEN = '.3.33.3.|.333333.|..3..3..|';
const EYES_SHUT = '.333333.|.333333.|..3..3..|';
const BODY = '.222222.|32222223|32222223|.211112.|';

export const STAND = frame(`${HELMET}${EYES_OPEN}${BODY}.11..11.|.11..11.|.22..22.|222..222|........`);
export const BLINK = frame(`${HELMET}${EYES_SHUT}${BODY}.11..11.|.11..11.|.22..22.|222..222|........`);
/** Tapping: the right foot comes up. */
export const TAP = frame(`${HELMET}${EYES_OPEN}${BODY}.11..11.|.11..22.|.22.222.|222.....|........`);

const SIDE_HEAD = '....33..|..11133.|.1111111|..111111|..333.3.|..333333|...333..|';
const ARMS = ['..2222..|..22223.|..2222..|..1111..|', '..2222..|..3222..|..2222..|..1111..|'];
const LEGS = [
  '.11..11.|11....11|2......2|22....22|........',
  '..1111..|...11...|...11...|..2222..|........',
  '..1111..|.11..11.|.1....1.|22....22|........',
  '..1111..|...11...|..11....|..222...|........',
];

function runFrame(i: number): Frame {
  return frame(`${SIDE_HEAD}${ARMS[i % 2] ?? ''}${LEGS[i] ?? ''}`);
}

export const RUN_RIGHT: readonly Frame[] = [0, 1, 2, 3].map(runFrame);
export const RUN_LEFT: readonly Frame[] = RUN_RIGHT.map(mirror);
